import React from "react";
import InputMask from 'react-input-mask';
import TableOne from "./TableOne";
import TableTwo from "./TableTwo";
import _ from "lodash";
import {
  Input,
  Button,
  Select,
  Collapse,
  AutoComplete,
  Transfer,
  TimePicker,
  Switch,
  Form
} from "antd";
const { Panel } = Collapse;
const { Option } = Select;

class FormOne extends React.Component {
  state = {
    mockData: [],
    targetKeys: [],
    initialValue: null,
    applicationValue: [],
  };

  async componentDidUpdate(prevProps, prevState) {
    const { initialValue, formRef } = this.props;
    if (
      prevProps.initialValue !== this.props.initialValue ||
      prevProps.finish !== this.props.finish
    ) {
      this.setState({ initialValue: this.props.initialValue });
      if (this.props.initialValue && this.props.initialValue.index_id) {

        await this.setState({ targetKeys: this.props.initialValue.index_id });
        if (initialValue.app_indexes_order) {
          const applicationsValues = [];
          const custom2Values = {};
          initialValue.app_indexes_order.forEach((e) => {
            applicationsValues.push(e.app_id);
            custom2Values[e.app_id] = {}
            if (e.index_order) {
              e.index_order.forEach((f) => {
                custom2Values[e.app_id][f.index_id] = {}
                custom2Values[e.app_id][f.index_id].order = f.order;
              });
            }
          });
          await this.setState({ applicationValue: applicationsValues });
          formRef.current.setFieldsValue({ applications: applicationsValues, custom2: custom2Values });
        }

      } else {
        this.setState({ targetKeys: [], applicationValue: [], initialValue: null });
      }
    }
  }

  handleChange = (targetKeys) => {
    this.setState({ targetKeys });
  };

  applicationsOnChange = async (value) => {

    await this.setState({ applicationValue: value });

  };

  setIndexValues = async (solution) => {
    const { solutionsGetData, formRef } = this.props;
    const targetKeys = [];
    const setCustomValues = {};
    const applicationsValues = [];
    const custom2Values = {};

    if (solutionsGetData) {
      const selectedSolution = solutionsGetData.find((e) => e.solution_name === solution);
      if (selectedSolution.default_indexes) {
        selectedSolution.default_indexes.forEach((e) => {
          targetKeys.push(e.index_id.toString());
          if (e.custom_values && e.custom_values_data) {
            setCustomValues[e.index_id] = e.custom_values_data;
          }
        });
      }

      if (selectedSolution.default_index_order) {

        selectedSolution.default_index_order.forEach((e) => {
          applicationsValues.push(e.app_id);
          custom2Values[e.app_id] = {}
          if (e.index_order) {
            e.index_order.forEach((f) => {
              custom2Values[e.app_id][f.index_id] = {}
              custom2Values[e.app_id][f.index_id].order = f.order;
            });
          }
        });
      }
    }
    await this.setState({ applicationValue: applicationsValues, targetKeys: targetKeys });
    formRef.current.setFieldsValue({ index_id: targetKeys, custom: setCustomValues, applications: applicationsValues, custom2: custom2Values });
  }

  generateProjectID() {
    const { hmgGetData, formRef } = this.props;
    const hmgId = formRef?.current?.getFieldValue("hmg_id");
    const projects = hmgGetData
      .filter((item) => {
        if (hmgId) {
          if (item.hmg_id === hmgId) {
            return true;
          }
        }
        return false;
      });
    let number = 1;
    while (projects.some(projects => projects.project_id === number)) {
      number++;
    }
    return number;
  }

  solutionOnChange = async (value) => {
    const { createStatus, excludeReset, formRef } = this.props;
    if (createStatus) {
      if (value === "PNA") {
        excludeReset();
        this.setIndexValues("Paperless Night Audit");
        formRef.current.setFieldsValue({ signature_type: "NONE", smart_scan_type: "0" });
      } else if (value === "Contract Storage") {
        await this.setState({ targetKeys: [], applicationValue: [] });
        excludeReset();
        this.setIndexValues("Contract Storage");
      } else {
        await this.setState({ targetKeys: [], applicationValue: [] });
        excludeReset();
      }
       formRef.current.setFieldsValue({ project_id: this.generateProjectID(),  });
    }
  }



  render() {
    const {
      formRef,
      onFinish,
      hmgGetData,
      hmgMainGetData,
      applicationsGetData,
      indexesGetData,
      createStatus,
      current,
      next,
      prev,
      steps,
    } = this.props;

    const hmgIdValue = formRef?.current?.getFieldValue("hmg_id");

    const hmgIdOnChange = async (value) => {
      await formRef.current.resetFields(["project_name_1"]);
      this.props.projectName1AutoCompleteOnChangeFunction(formRef?.current?.getFieldValue("project_name_1"), value);
    };

    const projectName1AutoCompleteOnChange = (value) => {
      this.setState({ targetKeys: [] });
      this.props.projectName1AutoCompleteOnChangeFunction(value, hmgIdValue);
    };

    const dataSource = hmgGetData
      .filter((item) => {
        if (hmgIdValue) {
          if (item.hmg_id === hmgIdValue) {
            return true;
          }
        }
        return false;
      })
      .map((d) => {
        return { value: d.project_name };
      });

    const hmgMainOptions = hmgMainGetData.map((d) => (
      <Option key={d._id}>{d.hmg_name}</Option>
    ));
    const applicationsOptions = applicationsGetData.map((d) => (
      <Option key={d._id}>{d.app_name}</Option>
    ));



    return (
      <div>
        <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
          <Panel
            header={_.startCase(_.camelCase(steps[current].title))}
            key="2_1"
          >
            <Form
              ref={formRef}
              labelCol={{
                xs: { span: 24 },
                sm: { span: 6 },
                md: { span: 6 },
                lg: { span: 5 },
                xl: { span: 5 },
                xxl: { span: 5 },
              }}
              wrapperCol={{
                xs: { span: 24 },
                sm: { span: 18 },
                md: { span: 18 },
                lg: { span: 15 },
                xl: { span: 12 },
                xxl: { span: 12 },
              }}
              onFinish={onFinish}
              onKeyPress={(e) => e.key === "Enter" ? e.preventDefault() : ''}
            >
              <Form.Item name="_id" label="Id" style={{ display: "none" }}>
                <Input />
              </Form.Item>

              <div
                style={
                  current === 0 ? { display: "block" } : { display: "none" }
                }
              >
                <Form.Item name="hmg_id" label="Hotel Management Group"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Hotel Management Group",
                    },
                  ]}
                >

                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Enter Hotel Management Group"
                    onChange={hmgIdOnChange}
                  >
                    {hmgMainOptions}
                  </Select>

                </Form.Item>

                <Form.Item name="project_name_1" label="Project Name"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Project Name",
                    },
                  ]}
                >

                  <AutoComplete
                    options={dataSource}
                    placeholder="Enter Project Name"
                    filterOption={(inputValue, option) =>
                      option.value
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onChange={projectName1AutoCompleteOnChange}
                    allowClear={true}
                  />

                </Form.Item>

                <div
                  className="is_animation_1"
                  style={
                    createStatus ? { maxHeight: "0" } : { maxHeight: "100px" }
                  }
                >
                  <Form.Item name="project_name" label="Rename Project Name"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Rename Project Name",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Rename Project Name" />
                  </Form.Item>
                </div>

                <Form.Item name="solution" label="Solution"
                  rules={[
                    { required: true, message: "Please Enter Solution" },
                  ]}
                >

                  <Select
                    placeholder="Enter Solution"
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={null}
                    onChange={this.solutionOnChange}
                  >
                    <Option value="PNA">PNA</Option>
                    <Option value="MYP">MYP</Option>
                    <Option value="BNF">BNF</Option>
                    <Option value="Contract Storage">Contract Storage</Option>
                    <Option value="Payroll">Payroll</Option>
                    <Option value="AP">AP</Option>
                  </Select>

                </Form.Item>

                <Form.Item name="project_id" label="Project ID" className="remove-multiple-error-message is-input-mask"
                  initialValue=""
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Project ID",
                    },
                    {
                      validator: (rule, value) => {
                        if (value > 0) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject("Project ID cannot be 0");

                        }
                      },
                    },
                  ]}
                >
                  <InputMask
                    mask="999999999"
                    placeholder="Enter Numbers Only"
                    className="ant-input"
                    maskChar={null}
                  />
                </Form.Item>

                <Form.Item name="signature_type" label="Signature Style"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signature Style",
                    },
                  ]}
                >

                  <Select
                    placeholder="Enter Signature Style"
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={null}
                  >
                    <Option value="NONE">NONE</Option>
                    <Option value="MARRIOTT_STYLE">MARRIOTT_STYLE</Option>
                    <Option value="HIGHGATE_STYLE">HIGHGATE_STYLE</Option>
                    <Option value="CRESCENT_STYLE">CRESCENT_STYLE</Option>
                    <Option value="CRESCENT_ONLY_STYLE">
                      {" "}
                      CRESCENT_ONLY_STYLE
                    </Option>
                    {/* <Option value="FREE_FORM_SIGNING_STYLE">FREE_FORM_SIGNING_STYLE</Option> */}
                    <Option value="MARRIOTT_STYLE_WITH_TEMPLATE">
                      MARRIOTT_STYLE_WITH_TEMPLATE
                    </Option>
                    <Option value="SIGNATURE_END_ENVELOPE_STYLE">
                      SIGNATURE_END_ENVELOPE_STYLE
                    </Option>
                  </Select>

                </Form.Item>

                <Form.Item name="smart_scaning_timed_out" label="Smart Scanning Timed Out">

                  <TimePicker
                    format="HH:mm"
                    style={{ width: "100%" }}
                    placeholder="Enter Smart Scanning Timed Out"
                  />

                </Form.Item>



                <Form.Item name="smart_scan_type" label="Smart Scan Type"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Smart Scan Type",
                    },
                  ]}
                >

                  <Select
                    placeholder="Enter Smart Scan Type"
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={null}
                  >
                    <Option value="2">Parent</Option>
                    <Option value="1">Yes</Option>
                    <Option value="0">No</Option>
                  </Select>

                </Form.Item>
                <Form.Item name="split_by_sub_header" label="Split Reports By Sub Header Type"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Split Reports By Sub Header Type",
                    },
                  ]}
                  initialValue="2"
                >

                  <Select
                    placeholder="Enter Split Reports By Sub Header Type"
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={null}
                  >
                    <Option value="2">Parent</Option>
                    <Option value="1">Yes</Option>
                    <Option value="0">No</Option>
                  </Select>
                </Form.Item>
                <Form.Item name="finance_checklist" label="Daily Finance Checklist" valuePropName="checked"
                >
                  <Switch />
                </Form.Item>



                <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                  <Button type="primary" onClick={next}>
                    Next
                  </Button>
                </Form.Item>
              </div>

              <div
                style={
                  current === 1 ? { display: "block" } : { display: "none" }
                }
              >
                <div style={{ display: "flex", justifyContent: "center" }}>

                  <Form.Item
                    name="index_id"
                    noStyle

                  >

                    <Transfer
                      dataSource={indexesGetData}
                      showSearch
                      rowKey={(record) => record._id}
                      lazy={false}
                      listStyle={{
                        width: 300,
                        height: 400,
                      }}
                      filterOption={(inputValue, option) =>
                        option.name
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) > -1
                      }
                      render={(item) => item.name}
                      onChange={this.handleChange}
                      targetKeys={this.state.targetKeys}
                      locale={{
                        itemUnit: "Index",
                        itemsUnit: "Indexes",
                        notFoundContent: "No indexes",
                        searchPlaceholder: "Search here",
                      }}
                    />

                  </Form.Item>
                </div>

                <div style={{ marginTop: "30px" }}>


                  <TableOne
                    // formRef={getFieldValue}
                    indexesGetData={indexesGetData}
                    targetKeys={this.state.targetKeys}
                    initialValue={this.state.initialValue}

                  />


                </div>

                <div style={{ textAlign: "center", marginTop: "30px" }}>
                  <Button onClick={prev} style={{ marginRight: 8 }}>
                    Previous
                  </Button>

                  <Button type="primary" onClick={next}>
                    Next
                  </Button>
                </div>
              </div>

              <div
                style={
                  current === 2 ? { display: "block" } : { display: "none" }
                }
              >
                <Form.Item name="applications" label="Applications">

                  <Select
                    mode="multiple"
                    placeholder="Enter Solution"
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={null}
                    onChange={this.applicationsOnChange}
                  >
                    {applicationsOptions}
                  </Select>

                </Form.Item>


                <TableTwo
                  applicationsGetData={applicationsGetData}
                  indexesGetData={indexesGetData}
                  targetKeys={this.state.targetKeys}
                  initialValue={this.state.initialValue}
                  applicationValue={this.state.applicationValue}
                  formRef={formRef}
                />


                <div style={{ textAlign: "center", marginTop: "30px" }}>
                  <Button onClick={prev} style={{ marginRight: 8 }}>
                    Previous
                  </Button>

                  <Button type="primary" htmlType="submit">
                    {createStatus ? "Create" : "Update"}
                  </Button>
                </div>
              </div>
            </Form>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default FormOne;
